module.exports = __webpack_public_path__ + "static/907-bf3a8c0c65bc69edb71568f4031a06eb.png";